import React, { useEffect, useState } from 'react';
import Preloader from './components/Preloader';
import Nav from './components/Nav';
import Cursor from './components/ui/Cursor';
import ScrollProgress from './components/ui/ScrollProgress';
import Hero from './components/sections/Hero';
import Marquee from './components/sections/Marquee';
import Now from './components/sections/Now';
import Work from './components/sections/Work';
import Experience from './components/sections/Experience';
import About from './components/sections/About';
import Skills from './components/sections/Skills';
import Writing from './components/sections/Writing';
import Education from './components/sections/Education';
import Contact from './components/sections/Contact';

export default function App() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    document.documentElement.classList.toggle('is-loading', !ready);
    if (ready) window.scrollTo({ top: 0 });
  }, [ready]);

  return (
    <>
      <Preloader onDone={() => setReady(true)} />
      <div className="grain" aria-hidden />
      <ScrollProgress />
      <Cursor />
      <Nav ready={ready} />
      <main>
        <Hero ready={ready} />
        <Marquee />
        <Now />
        <Work />
        <Experience />
        <About />
        <Skills />
        <Writing />
        <Education />
      </main>
      <Contact />
    </>
  );
}
